import {rtkApi} from '../apiSlice';
import {rtkActionHandler} from '../rtkHandler';
import {getDashboardData, getUserModules} from "@/redux/apis/admin/shared";
import {DASHBOARD_PROPS} from "@/app/admin/dashboard/dashboardPage";

const apiWithPortalAdministrationTag = rtkApi.enhanceEndpoints?.({ addTagTypes: [] });

export const sharedApi = apiWithPortalAdministrationTag.injectEndpoints({
    endpoints: (builder) => ({
        getUserModules: builder.query<any, null>({
            queryFn: async () => {
                return rtkActionHandler(getUserModules());
            },
        }),
        getDashboardData: builder.mutation<any, DASHBOARD_PROPS>({
            queryFn: async (data: DASHBOARD_PROPS) => {
                return rtkActionHandler(getDashboardData(data));
            },
        }),
    })
});

export const {
    useGetUserModulesQuery,
    useGetDashboardDataMutation,
} = sharedApi;